import React, { useState } from 'react';
import { Box, Button, Link, Paper, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const CHAVE = 'aviso_cookies_visto';

/**
 * Aviso de cookies do primeiro acesso.
 *
 * A Plataforma usa apenas cookies essenciais -- `token`, `refresh_token` e
 * `user`, todos de sessão e segurança. Não há analytics, publicidade nem
 * qualquer rastreador de terceiros, então este aviso informa e não pergunta:
 * oferecer botões de "aceitar" e "recusar" sugeriria uma escolha que não
 * existe, e o item 3.1 da Política de Cookies e Privacidade é claro em dizer
 * que cookie essencial não é gerenciável.
 *
 * Se um dia entrar cookie não essencial (o item 2.2.1 prevê publicidade), aí
 * sim este componente vira um banner de consentimento com escolha granular --
 * e o item 3.2 remete essa gestão às configurações do navegador.
 *
 * A dispensa fica em localStorage, e não em cookie: guardar em cookie a
 * preferência sobre cookies é o tipo de coisa que confunde auditoria.
 */
const AvisoDeCookies = () => {
    const [visivel, setVisivel] = useState(() => {
        try {
            return localStorage.getItem(CHAVE) !== 'true';
        } catch (erro) {
            // Navegador com armazenamento bloqueado: melhor não exibir nada do
            // que exibir o aviso em toda navegação
            return false;
        }
    });

    const dispensar = () => {
        try {
            localStorage.setItem(CHAVE, 'true');
        } catch (erro) {
            // Sem onde guardar: fecha assim mesmo, dentro desta sessão
        }
        setVisivel(false);
    };

    if (!visivel) return null;

    return (
        <Box
            sx={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: theme => theme.zIndex.snackbar,
                p: { xs: 1.5, sm: 2 },
                display: 'flex',
                justifyContent: 'center',
                pointerEvents: 'none',
            }}
        >
            <Paper
                elevation={6}
                sx={{
                    pointerEvents: 'auto',
                    width: '100%',
                    maxWidth: 720,
                    borderRadius: '14px',
                    p: { xs: 2, sm: 2.5 },
                }}
            >
                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={2}
                    alignItems={{ xs: 'stretch', sm: 'center' }}
                >
                    <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1, lineHeight: 1.6 }}>
                        A Empiria usa apenas cookies necessários para manter você conectado e proteger a sua
                        conta. Não usamos cookies de publicidade nem rastreamento de terceiros. Detalhes na{' '}
                        <Link
                            component={RouterLink}
                            to="/privacidade"
                            sx={{ color: '#006a61', fontWeight: 600 }}
                        >
                            Política de Cookies e Privacidade
                        </Link>
                        .
                    </Typography>

                    <Button
                        variant="contained"
                        onClick={dispensar}
                        sx={{
                            bgcolor: '#006a61',
                            textTransform: 'none',
                            fontWeight: 600,
                            borderRadius: '8px',
                            height: 40,
                            px: 3,
                            flexShrink: 0,
                            '&:hover': { bgcolor: '#005a52' },
                        }}
                    >
                        Entendi
                    </Button>
                </Stack>
            </Paper>
        </Box>
    );
};

export default AvisoDeCookies;
